<template>
	<div>
		<div class="sm:hidden">
			<select aria-label="Selected tab" class="form-select block w-full" :value="value" @input="$emit('input', $event.target.value)">
				<option v-for="(tab, index) in tabs" :key="index" :value="index">{{ tab.label }}</option>
			</select>
		</div>
		<div class="hidden sm:block">
			<nav class="flex">
				<template v-for="(tab, index) in tabs">
					<button
						:key="index"
						:class="{'bg-white shadow border-b-2 border-turquoise' : index == value }"
						class="inline-flex items-center px-4 py-2 font-medium text-sm leading-5 rounded-sm text-gray-600 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-turquoise focus:bg-white focus:border-white"
						@click="$emit('input', index)">
						{{ tab.label }}
						<!-- Badge: a count, or a plain dot when the tab only signals there is something new !-->
						<template v-if="tab.badge">
							<span v-if="isCounter(tab.badge)"
								  class="ml-2 inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-turquoise px-1.5 text-xs font-semibold text-white">
								{{ tab.badge }}
							</span>
							<span v-else class="ml-2 h-2 w-2 rounded-full bg-turquoise" aria-hidden="true"></span>
						</template>
					</button>
				</template>
			</nav>
		</div>
	</div>
</template>

<script>
export default {
	name: "Tabs",
	props: {
		value: [String, Number],
		/**
		 * Each item is a label, or {label, badge} where badge is a count or true for a dot
		 */
		itens: Array
	},
	computed: {
		tabs() {
			return (this.itens ?? []).map(item => {
				return typeof item === "object" && item !== null ? item : {label: item, badge: null}
			})
		}
	},
	methods: {
		/**
		 * Check if the badge carries a number to show
		 * @param badge
		 * @returns {boolean}
		 */
		isCounter(badge) {
			return typeof badge === "number"
		}
	}
}
</script>
